import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import { t } from "i18next"
import React from "react";


export const SpainAbsenceWarning = ({ isOpen, onConfirm }: { isOpen?: boolean; onConfirm?: () => void}) => {

    const handleClose = (confirm: boolean) => () => {
        if (confirm && onConfirm) {
            onConfirm()
        }
    }

    return (
        <Dialog open={isOpen ? true : false} onClose={handleClose(false)} aria-labelledby="spain-absence-warning-title">
            <DialogTitle id="spain-absence-warning-title">{t('spainAbsenceWarning.title')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('spainAbsenceWarning.description')}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose(true)} autoFocus color="error">{t('spainAbsenceWarning.confirm')}</Button>
            </DialogActions>
        </Dialog>
    )
}
